import React, { Component } from "react";
import { getCurrentDateTime } from "../../utils/commonUtiltyFunctions";
import { Strings, ChangeLanguage } from "INTL/i18n";
import changeLanguage from "MODULES/App/actions/ChangeLanguage";
import { PayerParam, PaymentParam } from "./PayerConstants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MDBTable, MDBTableBody } from "mdbreact";

import "./Payer.less";

class PaymentResult extends Component {
  state = {
    result: [],

    redirectUrl: "",
  };

  componentDidMount() {
    let searchQueryString = window.location.hash.split("?")[1];
    let urlParams = new URLSearchParams(searchQueryString);
    let languageCode = urlParams.get(PayerParam.lang);
    let redirectQueryString = "?" + window.location.hash.split("?")[2];
    let redirectUrl;
    if (urlParams.get(PayerParam.redirect)) {
      redirectUrl = urlParams.get(PayerParam.redirect) + redirectQueryString;
    }

    //chnage language
    ChangeLanguage(languageCode);
    this.props.changeLanguageInState(languageCode);
    //get current date
    let dateTimeStr = getCurrentDateTime();

    let queryParams = Object.keys(PaymentParam);
    let payerResult = [];
    var i = 0;
    queryParams.forEach((key, index) => {
      let paramValue = urlParams.get(PaymentParam[key]);

      if (paramValue !== null && paramValue !== "null") {
        let object = {
          id: i,
         
          name: PaymentParam[key] === "date"? Strings(PaymentParam[key]) 
          :Strings(PaymentParam[key]) + " " + Strings("id"),
          value: paramValue,
        };
        payerResult = [...payerResult, object];
        i++;
      }
    });
    payerResult = [...payerResult];

    this.setState({
      redirectUrl: redirectUrl,
      result: payerResult,
    });
  }

  handleClick = (event) => {
    window.location.replace(this.state.redirectUrl);
  };

  renderTableData() {
    return this.state.result.map((res, index) => {
      const { id, name, value } = res; //destructuring
      if (value) {
        return (
          <tr
            key={id}
            className={
              this.props.selectedLanguage === "ar"
                ? "resultPayerAr"
                : "resultPayer"
            }
          >
            <td className="Table_Label">{name}</td>
            <td className="Table_Value">{value}</td>
          </tr>
        );
      }
    });
  }
  render() {
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var marginValue = isMobile?"20px":"30px"
    let tableStyle = {
      fontSize: "15px",
      marginTop: "58px",
      marginLeft: marginValue,
      marginRight: marginValue,
    };
    return (
      <div style={tableStyle}>
        <MDBTable>
          <MDBTableBody borderless>{this.renderTableData()}</MDBTableBody>
        </MDBTable>
        {this.state.redirectUrl && (
          <p>
            <div className="hyperlink">
              <span onClick={this.handleClick}>
                {Strings("clickHereText")}
                {Strings("clickHere")}
              </span>
            </div>
          </p>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    selectedLanguage: state.LanguageReducer.selectedLanguage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLanguageInState: changeLanguage,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentResult);



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentResult.js